import { useEffect, useRef, useState } from 'react';

// Slim indeterminate progress bar pinned to the top of the viewport.
// Driven by the `api:active` window event from utils/api.js. Unlike the old
// full-screen overlay it never blocks interaction, and it only appears when a
// request takes longer than 200ms, so fast requests do not flash the UI.
const GlobalProgress = () => {
  const [visible, setVisible] = useState(false);
  const showTimerRef = useRef(null);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      const active = e.detail || 0;
      if (active > 0) {
        if (hideTimerRef.current) { clearTimeout(hideTimerRef.current); hideTimerRef.current = null; }
        if (!showTimerRef.current) {
          showTimerRef.current = setTimeout(() => setVisible(true), 200);
        }
      } else {
        if (showTimerRef.current) { clearTimeout(showTimerRef.current); showTimerRef.current = null; }
        // Keep the bar up briefly so quick bursts do not strobe.
        hideTimerRef.current = setTimeout(() => setVisible(false), 250);
      }
    };
    window.addEventListener('api:active', handler);
    return () => {
      window.removeEventListener('api:active', handler);
      if (showTimerRef.current) clearTimeout(showTimerRef.current);
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    };
  }, []);

  if (!visible) return null;

  return (
    <div aria-hidden="true" style={{
      position: 'fixed', top: 0, left: 0, right: 0, height: '3px',
      zIndex: 5000, pointerEvents: 'none', overflow: 'hidden',
      background: 'var(--coral-tint)',
    }}>
      <div className="global-progress-bar" />
    </div>
  );
};

export default GlobalProgress;
